import {Action} from "@ngrx/store";
import {DbResponse} from '../../shared/interceptors/db-response';

export const GENERATE_API_KEY: string = '[10Web API] Generate API Key';
export const GENERATE_API_KEY_SUCCESS: string = '[10Web API] Generate API Key Success';
export const GENERATE_API_KEY_FAIL: string = '[10Web API] Generate API Key Fail';

export const GET_RESELLER_CLIENT_DATA: string = '[10Web API] Get Reseller Client Data';
export const GET_RESELLER_CLIENT_DATA_SUCCESS: string = '[10Web API] Get Reseller Client Data Success';
export const GET_RESELLER_CLIENT_DATA_FAIL: string = '[10Web API] Get Reseller Client Data Fail';

export const GET_RESELLER_MAIN_DOMAIN: string = '[10Web API] Get Reseller Main Domain';
export const GET_RESELLER_MAIN_DOMAIN_SUCCESS: string = '[10Web API] Get Reseller Main Domain Success';
export const GET_RESELLER_MAIN_DOMAIN_FAIL: string = '[10Web API] Get Reseller Main Domain Fail';

// New actions for WordPress plugin details
export const LOAD_WORDPRESS_PLUGIN_DETAILS: string = '[10Web API] Load WordPress Plugin Details';
export const LOAD_WORDPRESS_PLUGIN_DETAILS_SUCCESS: string = '[10Web API] Load WordPress Plugin Details Success';
export const LOAD_WORDPRESS_PLUGIN_DETAILS_FAIL: string = '[10Web API] Load WordPress Plugin Details Fail';

// Action to refresh enhanced plugins after save
export const REFRESH_ENHANCED_PLUGINS: string = '[10Web API] Refresh Enhanced Plugins';

export class GenerateApiKey implements Action {
  readonly type: string = GENERATE_API_KEY;
}

export class GenerateApiKeySuccess implements Action {
  readonly type: string = GENERATE_API_KEY_SUCCESS;
  constructor(public payload: DbResponse) {}
}

export class GenerateApiKeyFail implements Action {
  readonly type: string = GENERATE_API_KEY_FAIL;
  constructor(public payload: any) {}
}

export class GetResellerClientData implements Action {
  readonly type: string = GET_RESELLER_CLIENT_DATA;
}

export class GetResellerClientDataSuccess implements Action {
  readonly type: string = GET_RESELLER_CLIENT_DATA_SUCCESS;
  constructor(public payload: DbResponse) {}
}

export class GetResellerClientDataFail implements Action {
  readonly type: string = GET_RESELLER_CLIENT_DATA_FAIL;
  constructor(public payload: any) {}
}

export class GetResellerMainDomain implements Action {
  readonly type: string = GET_RESELLER_MAIN_DOMAIN;
}

export class GetResellerMainDomainSuccess implements Action {
  readonly type: string = GET_RESELLER_MAIN_DOMAIN_SUCCESS;
  constructor(public payload: DbResponse) {}
}

export class GetResellerMainDomainFail implements Action {
  readonly type: string = GET_RESELLER_MAIN_DOMAIN_FAIL;
  constructor(public payload: any) {}
}

// New actions classes for WordPress plugin details
export class LoadWordPressPluginDetails implements Action {
  readonly type: string = LOAD_WORDPRESS_PLUGIN_DETAILS;
  constructor(public payload: {plugins: any[]}) {}
}

export class LoadWordPressPluginDetailsSuccess implements Action {
  readonly type: string = LOAD_WORDPRESS_PLUGIN_DETAILS_SUCCESS;
  constructor(public payload: {enhancedPlugins: any[]}) {}
}

export class LoadWordPressPluginDetailsFail implements Action {
  readonly type: string = LOAD_WORDPRESS_PLUGIN_DETAILS_FAIL;
  constructor(public payload: any) {}
}

// New action class to refresh enhanced plugins
export class RefreshEnhancedPlugins implements Action {
  readonly type: string = REFRESH_ENHANCED_PLUGINS;
}

export type TenWebApiAction =
  | GenerateApiKey
  | GenerateApiKeySuccess
  | GenerateApiKeyFail
  | GetResellerClientData
  | GetResellerClientDataSuccess
  | GetResellerClientDataFail
  | GetResellerMainDomain
  | GetResellerMainDomainSuccess
  | GetResellerMainDomainFail
  | LoadWordPressPluginDetails
  | LoadWordPressPluginDetailsSuccess
  | LoadWordPressPluginDetailsFail
  | RefreshEnhancedPlugins;
